import React, { useContext, useEffect, useState } from "react";

import { Tabs, Tab, Box } from "@material-ui/core";
import DriveToThrive from "views/Dashboard/DriveToThrive/DriveToThrive";
import DormantAutomation from "views/Dashboard/DriveToThrive/DormanAutomation";






import Context from 'context/context';


 





export default function DriveToThriveTab() {
  const [value, setValue] = useState(0);
  const { state, dispatch } = useContext(Context);
let disable=true
  const handleChange = (event, newValue) => {
    if(state?.userInfo?.loyalty_organization_name === 'Henry Schein Dental'){
    setValue(newValue);
    }else {
      
      newValue=newValue==1?2:newValue
  

    setValue(newValue);

    }
  };

  // Optional: Store components in an array to easily switch
  const components = [
<DriveToThrive/>,
<DormantAutomation/>
];

 


  return (
    <Box>
  
      <Tabs value={value} onChange={handleChange} aria-label="Points Management Tabs"
      TabIndicatorProps={{
    style: { backgroundColor: '#007bff' }, // e.g., '#1976d2' for blue
  }}>
        <Tab label="Drive To Thrive"/>
        <Tab label="Dormant Automation"/>


        

      </Tabs>
   

      <Box sx={{ p: 2 }}>
      {components[value]}
    </Box>
    </Box>
  );
}
